// firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyD4YpGwaNgi4as0NCfhU65VOQudKUZNwkA",
    authDomain: "niraatanka-bef67.firebaseapp.com",
    projectId: "niraatanka-bef67",
    storageBucket: "niraatanka-bef67.firebasestorage.app",
    messagingSenderId: "145868625345",
    appId: "1:145868625345:web:ac18b9deddfe329ac60b40",
    measurementId: "G-BTNHE1G42H"
};

const app = initializeApp(firebaseConfig);

export const firebaseAnalytics = getAnalytics(app);